import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { markDuplicates } from 'store/Contextualization/AssetDetail/duplicateActions';
import Button from 'shared/ui/Button';
import { selectIsReadOnly } from 'store/Faraday/selectors';
import { useIntl } from 'react-intl';
import { PropTypes } from 'prop-types';
import { selectSelected, selectSelectedMainVulns, selectShowDetail } from 'store/Contextualization/AssetDetail/selectors';
import { unSelectAll } from 'store/Contextualization/AssetDetail/actions';
import get from 'lodash/get';
import { FEATURE_DUPLICATES, PERMISSION_TYPES } from 'Hooks/usePermission/permissions';
import { selectAllowedByFeature, selectAllowedByRole } from 'Hooks/usePermission/selector';
import DuplicateIcon from 'Screens/Contextualization/Manage/components/CustomActionBar/components/DuplicateButton/styled';
import ModalWarning from 'Common/Components/ModalWarning';

const DuplicateButton = ({ hasVulns, showModal }) => {
  const dispatch = useDispatch();
  const readonly = useSelector(selectIsReadOnly);
  const selectedVulns = useSelector((state) => selectSelected('vulns', state));
  const oneOrNoneVulnsSelected = selectedVulns.length <= 1;
  const showVulnDetail = useSelector((state) => selectShowDetail('vulns', state));
  const canUseDuplicates = useSelector((state) => selectAllowedByFeature(state, FEATURE_DUPLICATES, PERMISSION_TYPES.CREATE) && selectAllowedByRole(state, FEATURE_DUPLICATES, PERMISSION_TYPES.CREATE));
  const [showWarning, setShowWarning] = useState();
  const intl = useIntl();
  const title = intl.formatMessage({ id: 'vuln.detail.duplicates.markAsDuplicates' });
  const warningMessage = intl.formatMessage({ id: 'vuln.duplicates.modalWarning.message' });
  const selectedVulnsIDs = selectedVulns.map((v) => v.id);
  const mainsRelatedToSelection = useSelector(selectSelectedMainVulns);
  const mergingGroups = mainsRelatedToSelection.length > 1;
  const enabled = !readonly && !showVulnDetail && canUseDuplicates && hasVulns;

  const setDuplicates = () => {
    if (mergingGroups) {
      showModal();
    } else {
      const mainID = get(mainsRelatedToSelection, '[0].id', null);
      dispatch(markDuplicates(selectedVulnsIDs, mainID));
      dispatch(unSelectAll('vulns'));
    }
  };

  const onClick = () => {
    if (enabled) {
      if (!oneOrNoneVulnsSelected) setDuplicates();
      else setShowWarning(true);
    }
  };

  const onCloseWarning = () => setShowWarning(false);

  if (!canUseDuplicates) return null;

  return (
    <>
      <Button variant="ghost" startIcon={ <DuplicateIcon /> } title={ title } ariaLabel={ title } onClick={ onClick } disabled={ !enabled } />
      { showWarning && <ModalWarning onCloseCallback={ onCloseWarning } title={ 'Mark as Duplicate' } description={ warningMessage } /> }
    </>
  );
};

DuplicateButton.propTypes = {
  showModal: PropTypes.func.isRequired
};

export default DuplicateButton;
